export const content = /* html */`
<p align="center"><b><u>USER GUIDE </u></b></p>
<p align="center"><b><u>FORM FOR HIGH COURT JUDGES AND MASTERS</u></b></p>
<p align="center"><b><u>CIVIL AND COMMERCIAL</u></p>
<p>The following is a Guide to assist with the completion of the Civil and Commercial Form for Judges and Masters. The
  form is designed to capture specific data which is required by the Court for management decision making. A standard
  form is used across all the Member States and Territories. If there is anything additional which the judge wishes to
  state, it can be included in the comments section at the end of the form.</p>
<p>Data is to be submitted <b><u>within 2 weeks</u></b> after the end of every term:</p>
<p>Term 1 - Hilary (Jan-Easter)</p>
<p>Term 2 - Trinity (Easter-Summer recess)</p>
<p>Term 3 - Michaelmas (Sep-Christmas)</p>
<p>For data during any one of the Court's vacations; this data should be captured in the<b>next term's report, and
    a note to indicate this should be written in the comments section of the form</b>. Example, if matters were
  dealt with during the Christmas vacation, then this should be captured in the Term 1 report of the following year and
  reporting continued in like manner.</p>
<p><b><u></u></b></p>
<table class="">
  <tbody>
    <tr>
      <td width="360">
        <p ><b><u>SECTION A: TRIALS </u></b></p>
      </td>
      <td width="360">
        <p>Judges can refer to the monthly trials data submitted by their Registrars to assist with some parts of this
          section; the trials scheduled, trials conducted and reasons for adjournment<b><u></u></b></p>
      </td>
			<div id="sectionA"></div>
    </tr>
    <tr>
      <td width="360">
        <p>Parts 1. 2. and 3<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Ensure that the figures are included under the relevant case type; whether Civil or Commercial.</p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 1<b><u></u></b></p>
      </td>
      <td width="360">
        <p>The number of trials scheduled refers to all trials which were to be held for this period.</p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Parts 2 and<b> </b>3<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Note that trials which were scheduled should either be completed/disposed or adjourned.</p>
        <p><b>Trials scheduled=trials completed or disposed (part1) + trials adjourned (part 3a).</b></p>
        <p>The part heard adjournments in <span class="red-text">3b</span> would already be included as part of the trials adjourned in <span class="red-text">3a</span> and should
          not be counted twice in the above formula<b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 3 (b)<b><u></u></b></p>
      </td>
      <td width="360">
        <p>The number of part-heard trials should
          be<b>out of those adjourned</b>. Thus, the number of part-</del>heard trials cannot be more than the number adjourned however it can be
          less than or the same.<b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 3 (c)</p>
        <p>Parts 3 (d) and 3(e)</p>
      </td>
      <td width="360">
        <p>Reasons for adjournments of trials: Select one main/primary reason for each trial adjourned. The data should
          only apply to the first adjournment. The total here should be same for part 3(a) that is total trials
          adjourned. Use the + symbol on the online form to add additional reasons. Note that "other" is not to be used
          as a category for reason for adjournment/method of disposal throughout the form. All reasons should be
          specified.</p>
        <p>Parts 3 (d) and 3(e) capture information on further adjournments when more than 1 adjournment occurs for
          trials. Part 3(e) asks that only main/primary reasons be listed for instances where there have been further
          adjournments.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 4<b></p>
      </td>
      <td width="360">
        <p>State how many trials lasted up to the number of days specified: Example there can be 3 trials which lasted
          up to5 days and 2 which lasted up to 10 days etc.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p><b><u>SECTION B: JUDGMENTS AFTER TRIAL</u></b></p>
				<div id="sectionB"></div>
      </td>
      <td width="360">
        <p>This section requests data on judgments which are delivered<b><u>following</u></b> a trial.</p>
        
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 1</p>
      </td>
      <td width="360">
        <p>Written judgments delivered: Any judgment delivered fully in writing. These arise from the judge reserving
          the judgment</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 2<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Oral judgments delivered: This should only include oral judgments following a trial and <b>NOT</b>
          other oral decisions given from orders during a chamber hearing or open court session. Interim
          orders<b><u>are NOT</u></b> oral judgments after trial and should be included under oral decisions
          in the sectionfor open court and chamber hearings.</p>
        <p>Oral judgments with written reasons should be included as part of oral judgments.</p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p><b><u></u></b></p>
      </td>
      <td width="360">
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p><b><u>SECTION C: OPEN COURT MATTERS and CHAMBER HEARINGS</u></p>
				<div id="sectionC"></div>
      </td>
      <td width="360">
        <p>This should exclude trials and divorce matters because there are separate sections for these matters. Thus,
          all other matters apart from trials, divorce matters and ancillary matters which were open court and chamber
          matters should be included in this section.</p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 1<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Number of matters scheduled/listed should include all open court and chamber matters except trials, divorce
          matters, and ancillary relief matters.</p>
        <p>Example: Pretrial conferences, Judgment summons, Fixed date hearings Status Hearings, Adoptions,
          Applications, Case Management etc.</p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 2<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Number of matters where decisions were reserved: the decision has been held to be delivered at a later date;
          should include all open court and chamber matters reserved except trials, divorce matters and ancillary relief
          matters<b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 3<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Number of oral decisions delivered: A decision made during a hearing such as judgment summons orders,
          committal orders, interim orders.</p>
        <p>Pretrial orders should be included here but Judges who indicated that they would like to specify them can
          additionally do so in the comments section.</p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 4<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Number of written decisions delivered: Any decision delivered in writing after an open court/chamber hearing.
          These arise from reserved decisions<b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 5 (a)</p>
        <p><b><u></u></b></p>
        <p><b><u></u></b></p>
        <p><b><u></u></b></p>
        <p><b><u></u></b></p>
        <p>Part 5 (b)</p>
        <p><b><u></u></b></p>
        <p><b><u></u></b></p>
      </td>
      <td width="360">
        <p>Reasons for adjournment of open court and chamber matters. Select one main/primary reason for each matter
          adjourned. The reason should also apply to the first adjournment. The total should represent total matters
          adjourned. Use the +symbol on the online form to add additional reasons.</p>
        <p>Part 5 (b) captures other main/primary reasons for adjournment when matters were adjourned more than once.
        </p>
        <p><b><u></u></b></p>
        <p><b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 6<b><u></u></b></p>
      </td>
      <td width="360">
        <p>Methods of disposal of open court/chamber matters: This isa standard list based on commonality across all
          jurisdictions. Any additional reasons <b>with</b>figures should be written using the + symbol. The
          total should add up to the number of open court and chamber matters disposed since each matter would have one
          method of disposal.<b><u></u></b></p>
      </td>
    </tr>
    <tr>
      <td width="360"></td>
      <td width="360"></td>
    </tr>
    <tr>
      <td width="360">
        <p><b><u>SECTION E: DIVORCES (EXCLUDING TRIALS and CHAMBERMATTERS</u></b></p>
				<div id="sectionE"></div>
      </td>
      <td width="360"></td>
    </tr>
    <tr>
      <td width="360">
        <p>Parts 1,2,3,4,</p>
      </td>
      <td width="360">
        <p>These refer to divorce matters/matrimonial matters excluding ancillary matters. Ancillary matters are
          specifically asked for in Parts 5,6 and 7.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 1</p>
      </td>
      <td width="360">
        <p>Number of divorce matters/matrimonial applications (except ancillary relief matters) scheduled/listed.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 2</p>
      </td>
      <td width="360">
        <p>Number of divorce matters/matrimonial applications adjourned (except ancillary relief</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 3</p>
      </td>
      <td width="360">
        <p>Number of decrees nisi granted</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 4</p>
      </td>
      <td width="360">
        <p>Number of decrees absolute granted. This will give information on matrimonial matters disposed.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Parts 5,6,7</p>
      </td>
      <td width="360">
        <p>These parts refer to ancillary maters</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 5</p>
      </td>
      <td width="360">
        <p>Number of ancillary matters scheduled/listed</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 6</p>
      </td>
      <td width="360">
        <p>Number of ancillary matters adjourned.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 7</p>
      </td>
      <td width="360">
        <p>Methods of disposal of ancillary matters: Any additional reasons <b>with</b> figures should be
          written using the + symbol. The total should add up to the number of ancillary matters disposed of since each
          matter would have 1 method of disposal.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Parts 8(a) and (b)</p>
      </td>
      <td width="360">
        <p>Part 8: both parts a and b refer to all divorce matters including ancillary matters</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>Part 8 (a)</p>
        <p>Part 8(b)</p>
      </td>
      <td width="360">
        <p>Reasons for adjournments of <b>all</b> divorce matters (including ancillary matters). Select one
          main/primary reason for each matter adjourned but this is only for the first adjournment. The total should
          represent total divorce matters adjourned. Any additional reasons<b>with</b> figures should be
          written using the +symbol.</p>
        <p>Part 8(b) captures main reasons for instances where divorce matters were adjourned more than once</p>
      </td>
    </tr>
    <tr>
      <td width="360"></td>
      <td width="360"></td>
    </tr>
    <tr>
      <td width="360">
        <p>SECTION F</p>
				<div id="sectionF"></div>
      </td>
      <td width="360">
        <p>APPLICATIONS WITHOUT NOTICE/EX PARTE APPLICATIONS</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>SECTION G</p>
				<div id="sectionG"></div>
      </td>
      <td width="360">
        <p>APPLICATIONS REVIEWED AND MADE IN ADMINISTRATION OF ESTATESAND PROBATES</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p>SECTION H</p>
				<div id="sectionH"></div>
      </td>
      <td width="360">
        <p>OTHER APPLICATIONS (example land certificate matters, possessory title matters). Need to specify the type of
          application.</p>
        <p>Example: 6 applications of type land etc.</p>
      </td>
    </tr>
    <tr>
      <td width="360">
        <p><b><u>COMMENTS</u></b></p>
      </td>
      <td width="360">
        <p>The judge can include a short summary of any additional information which they need to provide.</p>
      </td>
    </tr>
  </tbody>
</table>
`

export const criminal = /* html */`
<p align="center"> <b><u>USER GUIDE FOR SOME SECTIONS OF THE </u></b>
</p>
<p align="center"> <b><u>FORM FOR HIGH COURT JUDGES AND MASTERS</u></b>
</p>
<p align="center"> <b><u>CRIMINAL</u></b> <b><u></u></b>
</p>
<p> The following is a Guide to assist with the completion of certain sections of the Criminal Form for Judges and
  Masters. The form is designed to capture specific data which is required by the Court for management decision making.
  A standard form is used across all the Member States and Territories. If there is anything additional which the judge
  wishes to state, it can be included in the comments section at the end of the form.
</p>
<p> Data is to be submitted <b><u>within 3 weeks</u></b> after the end of every term:
</p>
<p> Term 1 - Hilary (Jan-Easter)
</p>
<p> Term 2 - Trinity (Easter-Summer recess)
</p>
<p> Term 3 - Michaelmas (Sep-Christmas)
</p>

<p>For data during any one of the Court’s vacations; this data should be captured in the <b>next term’s report, and a note to indicate this should be written in the comments section of the form </b>.
Example, if matters were dealt with during the Christmas vacation, then this should be captured in the Term 1 report of the following year and reporting continued in like manner.
</p>
<div >
  <table class="">
    <tbody>
      <tr>
        <td width="307">
          <p class="red-text"> <b>SECTION A: DOCKET </b>
					<div  id="sectionA"></div>
					<br>
					<b class="red-text"> Numbers 1,2 and 3 </b>
					</p>

            <p>Number of cases carried over from previous term</p>
            <p>Number of new cases arriving onto the docket during current term </p>
            <p>Number of cases listed in total during current term</p>
				
          <p class="red-text">
					<b> Numbers 3,4 and 5 </b>
					</p>
          <p> Number of cases listed in total during current term </p>
          <p> Number of cases finished during current term </p>
          <p> Number of cases carried over to next term </p>
          <p class="red-text">
					<b> Numbers 11 and 12  </b>
					</p>
          <p> Number of trials started </p>
          <p> Number of trials completed to verdict </p>
        </td>
        <td width="316">
          <p> The number of cases listed in total during
            the current term should be the sum of cases carried over from
            the previous term and new cases arriving onto the docket in the current term </p>
          <p> The number of cases carried over should be calculated as number of cases listed in total minus number of
            cases finished during the current term </p>
          <p> Note that the number of trials completed to verdict must be equal to or less that trials started. Number
            of trials completed to verdict cannot be more than the trials started. </p> <p>
              In cases where a trial commenced from a previous term and is now completed to verdict, there should be a note made in the comments section to clarify.
            </p>
        </td>
      </tr>
      <tr>
        <td width="307">
          <p class="red-text">
						<b> SECTION B: COURT OUTPUT</b>
					</p>
            <p class="red-text"><b>Number 6</b></p>
            <p>Number of cases involving children </p>
          <p class="red-text">
            <b>Number 13 a</b>
          </p>
          <p> Number of trials awaiting finalization by sentencing after verdict </p>
					<p class="red-text">
						<b>Number 13 b </b>
					</p>
          <p> Number of trials awaiting sentencing for 3 months or more than 3 months after verdict </p>
					
					<div id="sectionB"></div>
        </td>
        <td width="316">
        <p>&nbsp;</p>
        <p>This refers to when the children are either victims or defendants or both </p>
          <p>
            This refers to all types of verdicts
          </p>
          <p>
            The number of trials in 13b should be <span class="red-text">OUT OF</span> the total in 13a. Ensure that once data is given in 13a there is a figure written in 13 b. 
          </p>
          <p> Example if there were 15 trials awaiting sentence after a verdict, but none were for more than 3 months,
            then responses for: 
            </p>
          <p> 13a should be 15 </p>
          <p> 13b should be 0 </p>
          <p> Example if there 10 trials awaiting sentencing after a verdict but 5 were for more than 3 months then
            responses for </p>
          <p> 13a should be 10 </p>
          <p> 13 b should be 5 </p>
          <p> <b><u></u></b> </p>
        </td>
      </tr>
      <tr>
        <td width="307">
					<p class="red-text">
					<b> Number 14 a</b>
					</p>
          <p> Total number of matters awaiting sentence after a guilty plea </p>
					<p class="red-text">
						<b> Number 14 b</b>
					</p>
          <p> Number of matters awaiting sentence for 3 months or more after a guilty plea: </p>
        </td>
        <td width="316">
          <p> The number of matters for 14b should be <span class="red-text"> OUT OF</span> the total in 14a. Ensure that once data is given in 14a
            there is a figure written in 14b. </p>
          <p> Example if there were 10 matters awaiting sentence after a guilty plea, but none were for more than 3
            months then responses for: </p>
          <p> 14a should be 10 </p>
          <p> 14b should be 0 </p>
        </td>
      </tr>
      <tr>

        <td width="307">
					<p class="red-text">
					<b> For 13b and 14b</b>
					</p>
          <p> Total number of matters awaiting sentence after a guilty plea </p>
					<p class="red-text">
						<b> Number 14 b</b>
					</p>
          <p> Number of matters awaiting sentence for 3 months or more after a guilty plea: </p>
        </td>
        <td width="316">
          <p> When matters/ trials are awaiting
            sentencing for a very long period, this can
            be clarified and explained in the
            comments section</p>
        </td>
      </tr>

      <tr>
        <td width="307">
					<p class="red-text">
						<b> Number 15</b>
					</p>
          <p> Number of trials adjourned </p>
					<p class="red-text">
						<b> Number 16 </b>
					</p>
          <p> Reasons for adjournment of trials (only for the first adjournment) </p>
        </td>
        <td width="316">
        <p>These may be trials adjourned after jury selection or before jury selection. For example, where a matter is ready and the trial does not get underway due to illness of key witness of counsel as the case may be</p>

        <p> For Number 16, write <span class="red-text">one major/primary reason</span> for adjournment of each trial so that the total corresponds
          with the number of trials adjourned in Number 15. Additionally, the reason should pertain only to the first
          adjournment for trials which may have been adjourned more than once. The online form allows one to add any
          additional reason/s not on the standard list. <span class="red-text">Do not use “other” as a category but specify each reason</span>. </p>
        </td>
      </tr>
      <tr>
        <td width="307">
					<p class="red-text">
						<b> Number 17 </b>
					</p>
          <p> Now many trials were adjourned more than once </p>
					<p class="red-text">
						<b> Number 18 </b>
					</p>
          <p> What were the main reasons for the further adjournments?</p>
        </td>
        <td width="316">
          <p> Numbers 17 and 18 are meant to capture a bit of information on when trials are adjourned more than once. This could mean also trials adjourned more than once in one session. All adjournments should be taken into consideration
          </p>
           <p> Only the main or more common reasons for further adjournments are required. The main reason for the first adjournment is
            already captured in Number 16. </p>
        </td>
      </tr>
      <tr>
        <td width="307">
					<p class="red-text">
						<b> Number 19 </b>
					</p>
          <p>Nature of cases listed for trial  </p>
        </td>
        <td width="316">
          <p> <span class="red-text">It is important that this information be included. It is specific to cases listed for
            trial.</span>
            
          </p>
          <p> Example </p>
          <p> Sexual Offences 3 </p>
          <p> Firearm Offences 4 </p>
          <p>Drug offences 6</p>
          <p> This is not intended to capture the specific
            offence charged but rather the nature of
            the offences: An Indictment can have
            several counts, but those counts would be
            of related type-offences. Liaise with your
            judge </p>
            <p>Some judges may prefer to list the specific
              offences and not the general nature and
              this is also acceptable</p>
        </td>
      </tr>
      <tr>
        <td width="307">
					<p class="red-text">
						<b>Number 20 </b>
					</p>
          <p>
            How many trials have lasted how long? <b><u></u></b> </p>
        </td>
        <td width="316">
          <p> Example can have 3 trials which lasted up to 5 days and 2 which lasted up to 10 days </p>
          <p> So this will be written using the online form as: </p>
          <p> Up to 5 days 3 </p>
          <p> Up to 10 days 2 </p>
          <p> <b><u></u></b> </p>
        </td>
      </tr>
      <tr>
        <td width="307">
          <p class="red-text"> <b>SECTION C: DECISIONS</b> </p>
					<p class="red-text">
						<b> Number 21 </b>
					</p>
          <p> Number of Oral decisions </p>
					<div id="sectionC"></div>
        </td>
        <td width="316">
          <p> Apart from Oral decisions only note that oral decisions with written reasons are also to be captured as
            oral decisions for number 21 </p>
        </td>
      </tr>
      <tr>
        <td width="307">
          <p class="red-text"> <b>SECTION D: COMMENTS</b> </p>
					<div id="sectionD"></div>
        </td>
        <td width="316">
          <p> The judge can enter any additional information they wish to include in this section </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
`
export const userGuide = /* html */`
<p align="center">
	<strong><u>TECHNICAL USER GUIDE </u></strong>
</p>
<p align="center">
	<strong><u>FORM FOR HIGH COURT JUDGES AND MASTERS</u></strong>
</p>

<ul class="browser-default">
	<li>
		The data will be submitted on a new form for every Term. Thus, three
		forms will be submitted every year.
	</li>
	<li>
		The forms for the current term will be available for completion until 3
		weeks after the end of the term. Once this timeline has passed the
		forms will no longer be available for that term.
	</li>
	<li>
		The judges and masters or designated staff will access the relevant
		form via the email address with an access code/password for the
		specific judge/master.
	</li>
	<li>
		Select "Create New" in the section for New Forms to start your data
		entry.
	</li>
	<li>
		Ensure you select the correct country.
	</li>
	<li>
		The User Guides for each form are available once the form is created by
		clicking "Instructions" at the top of the form or by clicking on the
		"?" next to the Section headings.
	</li>
	<li>
		There is a "Save" option at the top of your form which must be clicked
		on to save your work so that when you reenter to update the
		information, the previously entered data will be saved.
	</li>
	<li>
		Once updating after your first save, the previous form can be accessed
		under "My Submissions". Click "Edit" to see your data.
		Changes/additions can be saved by clicking the "Update" option at the
		top of your form.
	</li>
	<li>
		To download a copy of the form at any point; once you have entered data
		and saved/updated, click the "Download" button at the top of your form.
	</li>
	<li>
		Ensure your judge/master logs in to view and approve their data before
		final submission.
	</li>
	<li>
		When ready for final submission click "Final submission" at the bottom
		of your form. The judge/master will liaise internally with Court
		Administration and their clerks to determine who clicks the final
		submission option because it is an important step.
	</li>
	<li>
		After you do your final submission, you can view the data, but no more
		changes will be allowed. You can download a copy of your final
		submission, which is encouraged, to keep as your record.
	</li>
	<li>
		Once the deadline for submission has passed, the statistician will send
		the compiled data (excel database) to the Honorable Chief Justice.
	</li>
</ul>
<p>
	For assistance with any general issues contact the statistician at
</p>
<a href="mailto:mcenac@eccourts.org">mcenac@eccourts.org</a>
`